module.exports = "<dt-content-header state-title=\"'Developer Settings'\"></dt-content-header> <dt-tabs class=dt-tabs layout=column tabs=$ctrl.tabs on-tab-click=$ctrl.onTabClick($event)> </dt-tabs> <div ui-view=contentBody></div> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/developer-settings/developer-settings.html
// module id = O8Jr
// module chunks = 1